var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGradientWhiteCheckMark = function SvgGradientWhiteCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 3.726a2.523 2.523 0 0 1 1.078 3.032c-.32.87-.71 1.87-1.075 2.653-.364.782-.88 1.724-1.34 2.53a2.548 2.548 0 0 1-3.023 1.14 25.78 25.78 0 0 1-5.19-2.395 2.523 2.523 0 0 1-1.078-3.033c.32-.871.71-1.873 1.074-2.652.363-.78.88-1.723 1.341-2.529A2.548 2.548 0 0 1 7.01 1.331a25.78 25.78 0 0 1 5.19 2.395Z",
    fill: "currentColor",
    fillOpacity: 0.8,
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.513 2.733a2.127 2.127 0 0 0-1.84-1.94 21.816 21.816 0 0 0-6.056 0 2.127 2.127 0 0 0-1.84 1.94C.684 3.987.58 5.694.58 6.996c0 1.303.105 3.01.198 4.264.074.998.844 1.8 1.84 1.94 2.009.282 4.048.282 6.057 0a2.127 2.127 0 0 0 1.84-1.94c.092-1.252.197-2.957.197-4.264 0-1.307-.105-3.011-.198-4.263ZM7.91 6.03a.761.761 0 0 0-.064-1.079.77.77 0 0 0-1.084.064L4.704 7.32l-.413-.463a.77.77 0 0 0-1.084-.063.761.761 0 0 0-.064 1.078l.987 1.104a.77.77 0 0 0 1.148 0L7.91 6.031Z",
    fill: "currentColor",
    fillOpacity: 0.8
  })));
};

export default SvgGradientWhiteCheckMark;